import { useMemo } from 'react';
import { Select } from 'antd';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import {
  GroupDescriptionOption,
  GroupDescriptionRef,
} from '@atlas-frontend/sdk';

import translations from './GroupOrDescriptionSelect.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory('output-select');
addTranslations(translations);

export const GroupOrDescriptionSelect = (props: {
  options: [
    GroupDescriptionOption[],
    GroupDescriptionOption[],
    GroupDescriptionOption[],
  ];
  withGroupDescriptions?: boolean;
  isLoading?: boolean;
  onSelect?: (value: number | GroupDescriptionRef) => void;
}) => {
  const {
    withGroupDescriptions,
    isLoading,
    options: groupedOptions,
    onSelect,
    ...rest
  } = props;
  const { t } = useTranslation();
  const [
    descriptionGroupOptions,
    ungroupedDescriptionOptions,
    groupDescriptionOptions,
  ] = groupedOptions;

  const options = useMemo(
    () => [
      {
        key: 'description-groups',
        label: t('option-group.description-groups'),
        options: descriptionGroupOptions,
      },
      ...(withGroupDescriptions
        ? [
            {
              key: 'group-descriptions',
              label: t('option-group.group-descriptions'),
              options: groupDescriptionOptions,
            },
          ]
        : []),
      {
        key: 'ungrouped-descriptions',
        label: t('option-group.ungrouped-descriptions'),
        options: ungroupedDescriptionOptions,
      },
    ],
    [
      t,
      descriptionGroupOptions,
      withGroupDescriptions,
      groupDescriptionOptions,
      ungroupedDescriptionOptions,
    ],
  );

  return (
    <Select
      id="output"
      allowClear
      styles={{
        popup: { root: { width: 'max-content' } },
      }}
      filterOption={(input, option) =>
        Boolean(option?.label?.toLowerCase().includes(input.toLowerCase()))
      }
      showSearch
      options={options}
      loading={isLoading}
      onSelect={onSelect}
      {...rest}
    />
  );
};
